import React from 'react';

export default function ListarConcedentes(props) {
	const { listaDeConcedentes, onSelect } = props;

	return (
		<div>
			<h5>Selecione o Acordo de Cooperação em que este campo de estágio estará vinculado...</h5>
			<table className="table table-striped table-hover">
				<thead>
					<tr>
						<th></th>
						<th>Nome</th>
						<th>Ramo de Atividade</th>
						<th>Telefone</th>
						<th>Email</th>
					</tr>
				</thead>
				<tbody>
					{
						listaDeConcedentes.map(concedente => {
							return (
								<tr key={concedente.id} onClick={() => onSelect(concedente)}>
									<td style={{ whiteSpace: 'nowrap' }}>
										{concedente.identificacao_cadastral.tipo_de_cadastro}{': '}
										{concedente.identificacao_cadastral.codigo_de_cadastro}
									</td>
									<td>{concedente.nome}</td>
									<td>{concedente.ramo_atividade}</td>
									<td>{concedente.telefone}</td>
									<td>{concedente.email}</td>
								</tr>
							);
						})
					}
				</tbody>
			</table>
		</div>
	);
}
